/**
 * Social Feature Payloads
 *
 * Types for friend management, chat, player search, and blocking
 */
// ============================================================================
// DAILY FRIEND GIFT (10 Gold, once per friend per UTC day, collect-to-credit)
// ============================================================================
/** Gold granted per daily friend gift. Deliberately BELOW challenge rewards
 *  (10/15/25): gifts are minted and scale with friend count, so the social
 *  beat must never out-earn gameplay. Sending is connected-accounts-only. */
export const FRIEND_GIFT_GOLD = 5;
//# sourceMappingURL=SocialPayloads.js.map